module.exports = __webpack_public_path__ + "4577e7084be54e5b0f213034d196358b.svg";